import { setUser } from "~/store/user/actions";
import { setSidebarList } from "~/store/sidebar/actions";
import { logout } from "../auth/actions";

export const USER_INFO = {
	method: "get",
	url: "vc/user/info",
	onSuccess: async ({ response, dispatch }) => {
		const responseData = response.data;
		await dispatch(setUser(responseData.user));
		await dispatch(setSidebarList(responseData.menu));
		return responseData;
	},
	onError: ({ error, dispatch, navigate }) => {
		switch (error.statusCode) {
			case 401:
				alert("세션이 만료되었습니다.");
				dispatch(logout());
				navigate("/");
				break;
			default:
				break;
		}
		return error;
	},
};
